<template>
  <div style="height: 100%">
    <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.asName" style="width: 150px;" size="mini" placeholder="商户名称" clearable></el-input>
          <el-input v-model="formDatas.asId" style="width: 110px;" size="mini" placeholder="商户id" clearable></el-input>
          <el-select v-model="formDatas.waStatus" size="mini" clearable placeholder="本地状态" style="width: 150px;" @change="partserch">
            <el-option v-for="(name, key) in waStatusMap" :key="key" :label="name" :value="Number(key)"></el-option>
          </el-select>
          <el-input v-model="formDatas.applymentState" style="width: 170px;" size="mini" placeholder="微信申请单状态" clearable></el-input>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="">搜索</el-button>
          <el-button type="primary" size="mini" style="" @click="addOpen">生成进件单</el-button>
          <el-button type="warning" size="mini" style="" @click="bulkImport = true">补录导入</el-button>
          <el-button type="danger" size="mini" style="" @click="submitBatch()">批量提交</el-button>
          
            <el-button type="success" size="mini" style=" " @click="Out">导出</el-button>
          </div>
        </el-row>
        </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="waId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 编辑补录 -->
      <el-drawer :wrapperClosable="false" title="编辑进件补录资料" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer" size="40%">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 30px 15px;overflow-x: hidden;">
              <el-alert v-if="form.checkMsg" :title="'资料校验未通过项：' + form.checkMsg" type="warning" :closable="false" style="margin-bottom: 15px"></el-alert>
              <el-form-item label="主体类型" prop="waSubjectType">
                <el-select v-model="form.waSubjectType" style="width: 80%;" placeholder="请选择">
                  <el-option label="个体工商户" value="SUBJECT_TYPE_INDIVIDUAL"></el-option>
                  <el-option label="企业" value="SUBJECT_TYPE_ENTERPRISE"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="执照商户名称(微信审核)" prop="waMerchantName">
                <el-input v-model="form.waMerchantName" style="width: 80%;" placeholder="按营业执照名称填写,默认取商户名称;个体户不能以公司/企业/合作社结尾"></el-input>
              </el-form-item>
              <el-form-item label="执照注册地址(门店地址取此)" prop="waLicenseAddress">
                <el-input v-model="form.waLicenseAddress" style="width: 80%;" placeholder="按营业执照住所填写,须详细到街道/楼宇,如衡水市桃城区XX路XX号XX楼"></el-input>
              </el-form-item>
              <el-form-item label="营业执照注册号/统一社会信用代码" prop="waLicenseNumber">
                <el-input v-model="form.waLicenseNumber" style="width: 80%;" placeholder="15位注册号或18位统一社会信用代码"></el-input>
              </el-form-item>
              <el-form-item label="经营者/法人姓名" prop="waLegalPerson">
                <el-input v-model="form.waLegalPerson" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证号" prop="waIdCardNumber">
                <el-input v-model="form.waIdCardNumber" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="身份证有效期开始" prop="waCardPeriodBegin">
                <el-date-picker v-model="form.waCardPeriodBegin" type="date" value-format="yyyy-MM-dd" style="width: 80%;" placeholder="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="身份证有效期结束" prop="waCardPeriodEnd">
                <el-checkbox :value="form.waCardPeriodEnd === '长期'" @change="toggleCardLongTerm" style="margin-right: 10px;">长期</el-checkbox>
                <el-date-picker v-if="form.waCardPeriodEnd !== '长期'" v-model="form.waCardPeriodEnd" type="date" value-format="yyyy-MM-dd" style="width: 60%;" placeholder="选择日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="身份证住址(按身份证填写)" prop="waIdCardAddress">
                <el-input v-model="form.waIdCardAddress" style="width: 80%;" placeholder="身份证住址栏一字不差,如河北省邯郸市大名县XX乡XX村XX号"></el-input>
              </el-form-item>
              <el-form-item label="营业执照有效期开始">
                <el-date-picker v-model="form.waLicensePeriodBegin" type="date" value-format="yyyy-MM-dd" style="width: 80%;" placeholder="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="营业执照有效期结束(留空按长期)">
                <el-date-picker v-model="form.waLicensePeriodEnd" type="date" value-format="yyyy-MM-dd" style="width: 80%;" placeholder="留空则提交时自动按长期"></el-date-picker>
              </el-form-item>
              <el-form-item label="商户简称(默认商户名称)">
                <el-input v-model="form.waMerchantShortname" style="width: 80%;" placeholder="1-64字,不支持单纯人名"></el-input>
              </el-form-item>
              <el-form-item label="客服电话(默认法人手机号)">
                <el-input v-model="form.waServicePhone" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="联系邮箱(默认商户邮箱,无效时必填)">
                <el-input v-model="form.waContactEmail" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="结算规则ID" prop="waSettlementId">
                <el-input v-model="form.waSettlementId" style="width: 80%;" placeholder="留空自动匹配:个体户719/企业716(零售0.6%)"></el-input>
              </el-form-item>
              <el-form-item label="行业名称" prop="waQualificationType">
                <el-input v-model="form.waQualificationType" style="width: 80%;" placeholder="如餐饮"></el-input>
              </el-form-item>
              <el-form-item label="门店省市编码(解析不出时填)">
                <el-input v-model="form.waBizAddressCode" style="width: 80%;" placeholder="如邯郸市130400"></el-input>
              </el-form-item>
              <el-form-item label="开户银行简称(识别不出时填)">
                <el-input v-model="form.waAccountBank" style="width: 80%;" placeholder="如农业银行"></el-input>
              </el-form-item>
              <el-form-item label="结算账户类型">
                <el-select v-model="form.waBankAccountType" style="width: 80%;" placeholder="请选择">
                  <el-option label="对公账户" value="BANK_ACCOUNT_TYPE_CORPORATE"></el-option>
                  <el-option label="经营者个人银行卡(仅个体户)" value="BANK_ACCOUNT_TYPE_PERSONAL"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">确 定</el-button>
        </div>
      </el-drawer>
      <!-- 生成进件单 -->
      <el-dialog title="生成进件单(从商户列表选择)" :visible.sync="addDialog" width="50%" :before-close="addDialogClose">
        <el-form label-position="top">
          <el-form-item label="选择商户(可搜索,多选)">
            <el-select v-model="addForm.asIds" multiple filterable clearable placeholder="输入商户名称搜索" style="width: 100%">
              <el-option v-for="item in shopOptions" :key="item.asId" :label="item.asName + '(' + item.asId + ')'" :value="item.asId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div v-if="addResult">
          <el-alert :title="'创建' + (addResult['创建数'] || 0) + '条,跳过' + (addResult['跳过数'] || 0) + '条'" type="success" :closable="false" style="margin-bottom: 10px"></el-alert>
          <div style="max-height: 200px; overflow-y: auto;">
            <div v-for="(item, index) in (addResult['跳过明细'] || [])" :key="'s' + index" style="color: #E6A23C; font-size: 12px;">{{ item }}</div>
            <div v-for="(item, index) in (addResult['创建明细'] || [])" :key="'c' + index" style="color: #67C23A; font-size: 12px;">
              {{ item.asName }}({{ item.asId }}) {{ item.checkMsg ? '待补录：' + item.checkMsg : '资料完整' }}
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialog = false; getList()" size="mini">关 闭</el-button>
          <el-button type="primary" @click="addSure" size="mini" :loading="addLoading">生成进件单</el-button>
        </span>
      </el-dialog>
      <!-- 补录Excel导入 -->
      <el-dialog title="补录资料Excel批量导入" :visible.sync="bulkImport" width="60%" :before-close="bulkImportClose">
        <div style="margin: 0 10px 10px;display: flex;">
          <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
            :auto-upload="false" ref="bulk" multiple>
            <el-button size="medium" type="danger">点击上传</el-button>
          </el-upload>
          <el-button type="primary" :loading="templateLoading" @click="downloadTemplate"
            style="margin-left: 20px; height: 40px;">下载模板</el-button>
          <div style="margin-left: 20px; font-size: 12px; color: #909399; line-height: 40px;">
            仅商户id必填,留空列不更新;填写规范见模板第二个Sheet「填写说明」
          </div>
        </div>
        <div v-if="bulkResult">
          <el-alert :title="'导入成功' + (bulkResult['导入成功数'] || 0) + '条,失败' + (bulkResult['失败数'] || 0) + '条'"
            :type="(bulkResult['失败数'] || 0) > 0 ? 'warning' : 'success'" :closable="false" style="margin-bottom: 10px"></el-alert>
          <div style="max-height: 250px; overflow-y: auto;">
            <div v-for="(item, index) in (bulkResult['失败明细'] || [])" :key="index" style="color: #F56C6C; font-size: 12px;">{{ item }}</div>
          </div>
        </div>
      </el-dialog>
      <!-- 驳回原因 -->
      <el-dialog :title="'驳回原因-' + (auditRow.asName || '')" :visible.sync="auditDialog" width="50%">
        <el-table :data="auditList" size="mini" border>
          <el-table-column property="fieldName" label="资料项" width="180"></el-table-column>
          <el-table-column property="rejectReason" label="驳回原因"></el-table-column>
        </el-table>
      </el-dialog>
      <!-- 进件详情 -->
      <el-dialog :title="'进件详情-' + (detailRow.asName || '')" :visible.sync="detailDialog" width="72%" top="5vh">
        <div style="max-height: 72vh; overflow-y: auto;">
          <el-descriptions title="微信侧信息" :column="2" size="small" border style="margin-bottom: 15px;">
            <el-descriptions-item label="商户">{{ detailRow.asName }}({{ detailRow.asId }})</el-descriptions-item>
            <el-descriptions-item label="本地状态">{{ waStatusMap[detailRow.waStatus] || '-' }}</el-descriptions-item>
            <el-descriptions-item label="业务申请编号">{{ detailRow.businessCode || '-' }}</el-descriptions-item>
            <el-descriptions-item label="微信申请单号">{{ detailRow.applymentId || '-' }}</el-descriptions-item>
            <el-descriptions-item label="特约商户号">{{ detailRow.subMchid || '-' }}</el-descriptions-item>
            <el-descriptions-item label="微信申请单状态">{{ detailRow.applymentStateMsg || '-' }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{ detailRow.createtime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="更新时间">{{ detailRow.updatetime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="签约链接" :span="2">{{ detailRow.signUrl || '-' }}</el-descriptions-item>
            <el-descriptions-item label="失败原因" :span="2">
              <span style="color: #F56C6C;">{{ detailRow.failReason || '-' }}</span>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="补录资料(提交微信的依据)" :column="2" size="small" border style="margin-bottom: 15px;">
            <el-descriptions-item label="主体类型">{{ detailRow.waSubjectType === 'SUBJECT_TYPE_ENTERPRISE' ? '企业' : '个体工商户' }}</el-descriptions-item>
            <el-descriptions-item label="执照商户名称">{{ detailRow.waMerchantName || detailRow.asName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="执照注册地址" :span="2">{{ detailRow.waLicenseAddress || '默认取商户地址' }}</el-descriptions-item>
            <el-descriptions-item label="执照注册号">{{ detailRow.waLicenseNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="法人/经营者">{{ detailRow.waLegalPerson || '-' }}</el-descriptions-item>
            <el-descriptions-item label="法人身份证号">{{ detailRow.waIdCardNumber || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身份证住址">{{ detailRow.waIdCardAddress || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身份证有效期">{{ detailRow.waCardPeriodBegin || '-' }} ~ {{ detailRow.waCardPeriodEnd || '-' }}</el-descriptions-item>
            <el-descriptions-item label="执照有效期">{{ detailRow.waLicensePeriodBegin || '-' }} ~ {{ detailRow.waLicensePeriodEnd || '长期(自动)' }}</el-descriptions-item>
            <el-descriptions-item label="商户简称">{{ detailRow.waMerchantShortname || '默认商户名称' }}</el-descriptions-item>
            <el-descriptions-item label="客服电话">{{ detailRow.waServicePhone || '默认法人手机号' }}</el-descriptions-item>
            <el-descriptions-item label="联系邮箱">{{ detailRow.waContactEmail || '-' }}</el-descriptions-item>
            <el-descriptions-item label="结算账户类型">{{ detailRow.waBankAccountType === 'BANK_ACCOUNT_TYPE_PERSONAL' ? '经营者个人银行卡' : '对公账户' }}</el-descriptions-item>
            <el-descriptions-item label="开户银行">{{ detailRow.waAccountBank || '自动识别' }}</el-descriptions-item>
            <el-descriptions-item label="结算规则ID">{{ detailRow.waSettlementId || (detailRow.waSubjectType === 'SUBJECT_TYPE_ENTERPRISE' ? '留空自动:716(企业零售)' : '留空自动:719(个体户零售)') }}</el-descriptions-item>
            <el-descriptions-item label="行业名称">{{ detailRow.waQualificationType || '默认零售' }}</el-descriptions-item>
            <el-descriptions-item label="门店省市编码">{{ detailRow.waBizAddressCode || '自动解析' }}</el-descriptions-item>
            <el-descriptions-item label="资料校验" :span="2">
              <span style="color: #E6A23C;">{{ detailRow.checkMsg || '完整' }}</span>
            </el-descriptions-item>
          </el-descriptions>
          <div v-if="detailAudit && detailAudit.length">
            <div style="font-weight: bold; margin: 8px 0;">驳回明细</div>
            <el-table :data="detailAudit" size="mini" border>
              <el-table-column property="fieldName" label="资料项" width="180"></el-table-column>
              <el-table-column property="rejectReason" label="驳回原因"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getWxApplymentList, addWxApplyment, importWxApplymentExcel, updateWxApplyment, submitWxApplymentBatch, getWxApplymentCheck, getAjefShopListQuick } from "../../api/api";
export default {
  name: "WxApplyment",
  data() {
    return {
      waStatusMap: { 1: '待提交', 2: '已提交审核中', 3: '待账户验证/待签约', 4: '已完成', 5: '已驳回', 6: '提交失败/已作废' },
      dialog: false,
      form: {},
      rules: {
        waLicenseNumber: [{ required: true, message: '请输入营业执照注册号', trigger: 'blur' }],
        waLegalPerson: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
        waIdCardNumber: [{ required: true, message: '请输入法人身份证号', trigger: 'blur' }],
      },
      tableLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      key: 'waId',
      selectedRowKeysCollection: [],
      checkboxOption: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected }) => {
          this.changeSelectedRowKeys(row, isSelected, this.key);
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys, this.key);
        },
      },
      cellSelectionOption: { enable: true },
      cellStyleOption: {
        headerCellClass: ({ rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      formDatas: {
        asName: '',
        asId: '',
        waStatus: null,
        applymentState: '',
        currentPage: 1,
        pageSize: 20
      },
      // 生成进件单
      addDialog: false,
      addLoading: false,
      addResult: null,
      addForm: { asIds: [] },
      shopOptions: [],
      // 补录导入
      bulkImport: false,
      bulkResult: null,
      templateLoading: false,
      // 驳回原因
      auditDialog: false,
      auditList: [],
      auditRow: {},
      // 进件详情
      detailDialog: false,
      detailRow: {},
      detailAudit: [],
      columns: [
        { field: "", key: "checkbox", type: "checkbox", title: "", width: 50, align: "center" },
        { field: "", key: "a", title: "序号", width: 50, align: "center", renderBodyCell: ({ rowIndex }, h) => { return ++rowIndex; } },
        { field: "asName", key: "asName", title: "商户", width: 180, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return <span>{row.asName}<br />({row.asId})</span>;
          } },
        { field: "waSubjectType", key: "waSubjectType", title: "主体类型", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return <el-tag size="mini" type={row.waSubjectType === 'SUBJECT_TYPE_ENTERPRISE' ? '' : 'info'}>{row.waSubjectType === 'SUBJECT_TYPE_ENTERPRISE' ? '企业' : '个体工商户'}</el-tag>;
          } },
        { field: "waMerchantName", key: "waMerchantName", title: "执照商户名称", width: 160, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return <span>{row.waMerchantName || row.asName}</span>;
          } },
        { field: "waLegalPerson", key: "waLegalPerson", title: "法人", width: 80, align: "center", ellipsis: true },
        { field: "businessCode", key: "businessCode", title: "业务申请编号", width: 160, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return row.businessCode ? <el-link type="primary" underline={true} style="font-size: 12px;" on-click={() => this.showDetail(row)}>{row.businessCode}</el-link> : <span>-</span>;
          } },
        { field: "applymentId", key: "applymentId", title: "微信申请单号", width: 130, align: "center" },
        { field: "subMchid", key: "subMchid", title: "特约商户号", width: 110, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.subMchid ? <el-tag size="mini" type="success">{row.subMchid}</el-tag> : <span>-</span>;
          } },
        { field: "waStatus", key: "waStatus", title: "本地状态", width: 110, align: "center",
          renderBodyCell: ({ row }, h) => {
            const typeMap = { 1: 'info', 2: '', 3: 'warning', 4: 'success', 5: 'danger', 6: 'danger' };
            return <el-tag size="mini" type={typeMap[row.waStatus] || 'info'}>{this.waStatusMap[row.waStatus]}</el-tag>;
          } },
        { field: "applymentStateMsg", key: "applymentStateMsg", title: "微信状态", width: 120, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return <span>{row.applymentStateMsg || '-'}{row.applymentState === 'APPLYMENT_STATE_REJECTED' ? (
              <el-button type="text" size="mini" style="color:#F56C6C" on-click={() => this.showAudit(row)}>驳回明细</el-button>
            ) : null}</span>;
          } },
        { field: "checkMsg", key: "checkMsg", title: "资料校验", width: 150, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return row.waStatus === 1 ? (row.checkMsg ? <el-tooltip content={row.checkMsg} placement="top"><el-tag size="mini" type="warning">缺{row.checkMsg.split(';').length}项</el-tag></el-tooltip> : <el-tag size="mini" type="success">完整</el-tag>) : <span>-</span>;
          } },
        { field: "failReason", key: "failReason", title: "失败原因", width: 150, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return row.failReason ? <el-tooltip content={row.failReason} placement="top"><span style="color:#F56C6C">{row.failReason.substring(0, 30)}</span></el-tooltip> : <span>-</span>;
          } },
        { field: "signUrl", key: "signUrl", title: "签约链接", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.signUrl ? <el-button type="text" size="mini" on-click={() => this.copySignUrl(row)}>复制</el-button> : <span>-</span>;
          } },
        { field: "createtime", key: "createtime", title: "创建时间", width: 150, align: "center" },
        { field: "", key: "d", title: "操作", width: 150, align: "center", fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return (
              <div>
                <el-button type="text" size="mini" on-click={() => this.checkRow(row)}>查状态</el-button>
                {[1, 5, 6].includes(row.waStatus) ? (
                  <el-button type="text" size="mini" on-click={() => this.editorgan(row)}>编辑补录</el-button>
                ) : null}
              </div>
            );
          } },
      ],
    };
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = { ...this.formDatas };
      if (params.asId === '') delete params.asId;
      if (params.asName === '') delete params.asName;
      getWxApplymentList(params).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // ===== 编辑补录 =====
    editorgan(row) {
      this.form = { ...row };
      this.dialog = true;
    },
    // ===== 进件详情 =====
    showDetail(row) {
      this.detailRow = row;
      this.detailAudit = [];
      if (row.auditDetail) {
        try {
          this.detailAudit = JSON.parse(row.auditDetail) || [];
        } catch (e) {
          this.detailAudit = [];
        }
      }
      this.detailDialog = true;
    },
    //身份证有效期结束"长期"勾选(日期控件无法输入文本)
    toggleCardLongTerm(val) {
      this.form.waCardPeriodEnd = val ? '长期' : '';
    },
    handleClose() {
      this.dialog = false;
    },
    SureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$confirm('确认保存补录资料？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
            updateWxApplyment(this.form).then((res) => {
              this.$message.success('保存成功' + (res.data.checkMsg ? ',仍缺：' + res.data.checkMsg : ''));
              this.handleClose();
              this.getList();
            });
          });
        }
      });
    },
    // ===== 查询状态 =====
    checkRow(row) {
      this.openLoading();
      getWxApplymentCheck({ waId: row.waId }).then((res) => {
        this.loadings.close();
        this.getList();
      }).catch(() => {
        this.loadings.close();
      });
    },
    // ===== 驳回明细 =====
    showAudit(row) {
      this.auditRow = row;
      try {
        this.auditList = row.auditDetail ? JSON.parse(row.auditDetail) : [];
      } catch (e) {
        this.auditList = [];
      }
      this.auditDialog = true;
    },
    // ===== 生成进件单 =====
    addOpen() {
      this.addResult = null;
      this.addDialog = true;
      if (this.shopOptions.length === 0) {
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
          this.shopOptions = res.data || [];
        });
      }
    },
    addDialogClose(done) {
      done();
      this.getList();
    },
    addSure() {
      if (!this.addForm.asIds.length) {
        this.$message.warning('请先选择商户');
        return;
      }
      this.$confirm(`确认为选中的 ${this.addForm.asIds.length} 个商户生成进件单？`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        this.addLoading = true;
        addWxApplyment({ asIds: this.addForm.asIds.join(',') }).then((res) => {
          this.addLoading = false;
          this.addResult = res.data;
          this.addForm.asIds = [];
          this.getList();
        }).catch(() => {
          this.addLoading = false;
        });
      });
    },
    // ===== 批量提交 =====
    submitBatch() {
      const selected = this.selectedRowKeysCollection;
      let tip;
      let params;
      if (selected.length > 0) {
        tip = `确认提交选中的 ${selected.length} 条进件单？(仅待提交/已驳回/提交失败状态会实际提交)`;
        params = { waIds: selected.join(',') };
      } else {
        tip = '未勾选记录,确认提交全部可提交的进件单(待提交/已驳回/提交失败且资料校验通过)？';
        params = {};
      }
      this.$confirm(tip + ' 提交为串行限频操作,请耐心等待返回。', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        this.openLoading();
        submitWxApplymentBatch(params).then((res) => {
          this.loadings.close();
          const d = res.data || {};
          this.$alert(`提交总数:${d['提交总数'] || 0},成功:${d['提交成功数'] || 0},失败:${d['失败数'] || 0}<br/><div style="color:#F56C6C;font-size:12px;">${(d['失败明细'] || []).join('<br/>').substring(0, 3000)}</div>`,
            '批量提交结果', { dangerouslyUseHTMLString: true });
          this.checkboxOption.selectedRowKeys = [];
          this.selectedRowKeysCollection = [];
          this.getList();
        }).catch(() => {
          this.loadings.close();
        });
      });
    },
    // ===== 补录导入 =====
    updatabulk(file) {
      let Data = new FormData();
      Data.append('file', file.raw);
      this.openLoading();
      importWxApplymentExcel(Data).then(res => {
        this.loadings.close();
        this.bulkResult = res.data;
      }).catch(() => {
        this.loadings.close();
      });
    },
    bulkImportClose(done) {
      done();
      this.bulkResult = null;
      this.getList();
    },
    // 下载模板文件(后端动态生成,文件流下载)
    downloadTemplate() {
      this.templateLoading = true;
      var that = this;
      axios({
        method: 'post',
        url: config.baseURL + '/wx-applyment/exportWxApplymentImportTemplate',
        data: qs.stringify({}),
        timeout: 60000,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then(res => {
        that.templateLoading = false;
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', objectUrl);
        a.setAttribute('download', '进件补录导入模板.xlsx');
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        that.templateLoading = false;
      });
    },
    // ===== 复制签约链接 =====
    copySignUrl(row) {
      const input = document.createElement('input');
      input.value = row.signUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('签约链接已复制,发给商户超管微信打开完成签约');
    },
    // ===== checkbox =====
    changeSelectedRowKeys(row, isSelected, key) {
      const rowKey = row[key];
      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        const colIndex = this.selectedRowKeysCollection.indexOf(rowKey);
        if (colIndex > -1) {
          this.selectedRowKeysCollection.splice(colIndex, 1);
        }
      }
    },
    changeSelectAll(isSelected, selectedRowKeys, key) {
      this.checkboxOption.selectedRowKeys = selectedRowKeys;
      if (isSelected) {
        this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item) => {
          const idx = this.selectedRowKeysCollection.indexOf(item[key]);
          if (idx > -1) {
            this.selectedRowKeysCollection.splice(idx, 1);
          }
        });
      }
    },
    // ===== 导出 =====
    Out() {
      var s = qs.stringify(this.formDatas);
      this.openLoading();
      var that = this;
      axios({
        method: 'post',
        url: config.baseURL + '/wx-applyment/exportWxApplyment',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then(res => {
        that.loadings.close();
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', objectUrl);
        a.setAttribute('download', '微信特约商户进件.xlsx');
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        that.loadings.close();
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
  },
};
</script>

<style scoped>
</style>
